export function Icon({ name, side = 'left' }) {
  const paths = {
    panel: <><rect x="3" y="4" width="18" height="16" rx="4" /><path d={side === 'left' ? 'M9 4v16' : 'M15 4v16'} /></>,
    arrow: <><path d="M12 19V5m-6 6 6-6 6 6" /></>,
    close: <path d="m6 6 12 12M6 18 18 6" />,
    stop: <rect x="7" y="7" width="10" height="10" rx="2" />,
    gear: <><path d="M9.5 3h5l.6 2.7 1.7 1 2.6-.8 2.5 4.2-2 1.9v2l2 1.9-2.5 4.2-2.6-.8-1.7 1-.6 2.7h-5l-.6-2.7-1.7-1-2.6.8L2.1 16l2-1.9v-2l-2-1.9L4.6 6l2.6.8 1.7-1Z" transform="translate(0 -1)" /><circle cx="12" cy="12" r="3.25" /></>,
    link: <><path d="m10 13 4-4m-6 7-1 1a4 4 0 0 1-6-6l4-4a4 4 0 0 1 6 0m2-2 1-1a4 4 0 0 1 6 6l-4 4a4 4 0 0 1-6 0" /></>,
    file: <><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" /><path d="M14 3v6h6M8 13h8M8 17h5" /></>
  };
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
export function SidebarToggle({ side, open, onClick }) {
  const label = `${open ? 'Hide' : 'Show'} ${side === 'left' ? 'conversations' : 'references'}`;
  return <button type="button" className="arts-icon-button" aria-label={label} title={label} aria-expanded={open} onClick={onClick}><Icon name="panel" side={side} /></button>;
}
